<template>
  <div
    class="modal fade"
    id="addVehicleModal"
    tabindex="-1"
    aria-labelledby="addVehicleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <form @submit.prevent="formController()">
          <div class="modal-header">
            <h5 class="modal-title" id="addVehicleModalLabel">
              Agregar vehículo
            </h5>
            <button
              type="button"
              class="btn-close"
              @click.prevent="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <input type="hidden" id="id" name="id" v-model="model.id" />
            <div class="input-box">
              <label>Marca*</label>
              <select
                name="brand_id"
                id="brand_id"
                v-model="model.brand_id"
                @change="resetModel"
              >
                <option value="">Seleccionar</option>
                <option
                  v-for="brand in brands"
                  :value="brand.id"
                  :key="brand.id"
                >
                  {{ brand.name || brand.text }}
                </option>
              </select>
            </div>

            <div class="input-box">
              <label>Modelo*</label>
              <select
                name="vehicle_model_id"
                id="vehicle_model_id"
                v-model="model.vehicle_model_id"
                @change="resetVersion"
              >
                <option value="">Seleccionar</option>
                <option
                  v-for="vehicle_model in vehicleModels"
                  :value="vehicle_model.id"
                  :key="vehicle_model.id"
                >
                  {{ vehicle_model.name }}
                </option>
              </select>
            </div>

            <div class="input-box">
              <label>Versión</label>
              <select
                name="vehicle_version_id"
                id="vehicle_version_id"
                v-model="model.vehicle_version_id"
              >
                <option value="">Seleccionar</option>
                <option
                  v-for="vehicle_version in vehicleVersions"
                  :value="vehicle_version.id"
                  :key="vehicle_version.id"
                >
                  {{ vehicle_version.name }}
                </option>
              </select>
            </div>

            <div class="input-box">
              <label>Placa*</label>
              <input
                type="text"
                name="plate"
                id="plate"
                class="text-uppercase"
                v-model="model.plate"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn--outline"
              @click.prevent="closeModal()"
            >
              Cancelar
            </button>

            <button type="submit" class="btn btn--green">Registrar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { inject, reactive, ref, watchEffect } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

const props = defineProps({
  brands: {
    type: Array,
    default: () => [],
  },
  id: {
    type: [String, Number],
    default: '',
  },
  url_detail: {
    type: String,
    default: '',
  },
  url_get_vehicle_models: {
    type: String,
    default: '',
  },
  url_get_vehicle_versions: {
    type: String,
    default: '',
  },
  url_store: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['close-modal', 'refresh-table'])

const loading = inject('loading')
const vehicleModels = ref([])
const vehicleVersions = ref([])
const model = reactive({
  id: '',
  brand_id: '',
  vehicle_model_id: '',
  vehicle_version_id: '',
  plate: '',
  year: '',
})

const resetModel = () => {
  model.vehicle_version_id = ''
}

const resetVersion = () => {
  model.vehicle_version_id = ''
}

const formController = async () => {
  try {
    model.id = props.id

    const { data } = await axios.request({
      url: props.url_store,
      method: 'PUT',
      data: model,
    })

    if (data.type === 1) {
      $('#addVehicleModal').modal('hide')
      closeModal()
      emit('refresh-table')
    }

    customAlert(data)
  } catch (error) {
    console.error(error)
  }
}

const closeModal = () => {
  model.id = ''
  model.brand_id = ''
  model.vehicle_model_id = ''
  model.vehicle_version_id = ''
  model.plate = ''
  model.year = ''

  $('#addVehicleModal').modal('hide')
  emit('close-modal')
}

watchEffect(async () => {
  if (props.id !== '') {
    loading.value = true

    try {
      const { data } = await axios.request({
        url: props.url_detail,
        method: 'POST',
        data: { id: props.id },
      })

      if (data) {
        model.id = data.id
        model.brand_id = data.brand_id || ''
        model.vehicle_model_id = data.vehicle_model_id || ''
        model.vehicle_version_id = data.vehicle_version_id || ''
        model.plate = data.plate
        model.year = data.year
      }
    } catch (error) {
      console.error(error)
    }

    loading.value = false
  }
})

watchEffect(async () => {
  if (model.brand_id !== '') {
    loading.value = true

    try {
      const { data } = await axios.request({
        url: props.url_get_vehicle_models,
        method: 'GET',
        params: { brand_id: model.brand_id },
      })

      if (data) {
        vehicleModels.value = data
      }
    } catch (error) {
      console.error(error)
    }

    loading.value = false
  }
})

watchEffect(async () => {
  if (model.vehicle_model_id !== '') {
    loading.value = true

    try {
      const { data } = await axios.request({
        url: props.url_get_vehicle_versions,
        method: 'GET',
        params: { vehicle_model_id: model.vehicle_model_id },
      })

      if (data) {
        vehicleVersions.value = data
      }
    } catch (error) {
      console.error(error)
    }

    loading.value = false
  }
})
</script>
